<template>
	<BaseCard :title="$t('lawyers_offices').toString()">
		<div class="flex flex-col mb-10" v-if="!isLoading">
			<div>
				<div class="flex flex-row justify-between">
					<div class="w-80 mb-6">
						<BaseInput :filter-only="true" :label="$t('search')" v-model="sword" />
					</div>
					<div class="mt-8">
						<AddButton
							style="text-align: start; min-width: 240px; max-width: 240px"
							@click="$router.push({ name: 'repair_shop.service_provider.apply_lawyer_office' })"
							>{{ $t('apply_new_lawyers_office') }}</AddButton
						>
					</div>
				</div>

				<div class="m-4" v-if="this.getFilteredLawyerOffices && this.getFilteredLawyerOffices.length <= 0 && this.sword == null">
					<b>{{ $t('no_available_assessors') }}</b>
				</div>
				<div class="m-4" v-else-if="this.getFilteredLawyerOffices && this.getFilteredLawyerOffices.length <= 0 && this.sword != null">
					<b>{{ $t('no_entries_found') }}</b>
				</div>
				<div
					class="align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200 rounded"
					v-if="this.getFilteredLawyerOffices && this.getFilteredLawyerOffices.length > 0"
				>
					<table class="min-w-full">
						<thead class="w-full" style="height: fit-content;">
							<tr class="w-full">
								<HeaderColumn style="width: fit-content">{{ $t('service_provider') }}</HeaderColumn>
								<HeaderColumn>{{ $t('address') }}</HeaderColumn>
								<HeaderColumn>{{ $t('phone') }}</HeaderColumn>
								<HeaderColumn>{{ $t('e_mail') }}</HeaderColumn>
							</tr>
						</thead>
						<tbody class="bg-white">
							<tr v-for="(lawyerOffice, index) in getFilteredLawyerOffices" :key="lawyerOffice.id" class="tr odd:bg-gray-200">
								<td class="px-4 py-4 w-3/12" :class="getFilteredLawyerOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									<div>{{ lawyerOffice.ownerFirstname }} {{ lawyerOffice.ownerLastname }}</div>
									<div>{{ lawyerOffice.name }}</div>
								</td>
								<td class="py-4 w-3/12" :class="getFilteredLawyerOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ getAddress(lawyerOffice) }},
									{{ lawyerOffice.city.zipCode }}
									{{ lawyerOffice.city.name }}
								</td>
								<td class="py-4 w-1/12" :class="getFilteredLawyerOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ lawyerOffice.phoneNumber }}
								</td>
								<td class="py-4 w-3/12" :class="getFilteredLawyerOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ lawyerOffice.email }}
								</td>
								<td
									class="py-4 pr-4 w-2/12"
									style="text-align: end"
									:class="getFilteredLawyerOffices.length !== index + 1 ? 'border-b border-gray-200' : ''"
								>
									<Toggle :active="!lawyerOffice.isDisabled" @click="disableRow(lawyerOffice)" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import RepairShopRepository from '@/api/repositories/RepairShopRepository';
import AddButton from '@/components/forms/buttons/AddButton';
import Toggle from '@/components/forms/Toggle';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import HeaderColumn from '@/components/columns/HeaderColumn.vue';

export default {
	name: 'ServiceProviderLawyersOfficesCard',
	components: { HeaderColumn, BaseInput, Toggle, AddButton, BaseCard },
	data() {
		return {
			lawyersOffices: undefined,
			isLoading: true,
			sword: '',
		};
	},
	computed: {
		getFilteredLawyerOffices() {
			return this.lawyersOffices.filter(el => el.name.toLowerCase().includes(this.sword.toLowerCase()));
		},
	},
	methods: {
		getAddress(company) {
			if (company.street === undefined || company.street === null) {
				return this.$t('po_box') + ' ' + company.poBox;
			} else {
				if (company.houseNumber != null) {
					return `${company.street} ${company.houseNumber || ''}`;
				} else {
					return company.street;
				}
			}
		},
		getLawyers() {
			const repairshopId = this.$store.getters.getUser.person.company.companyable.id;
			RepairShopRepository.lawyersOffices(repairshopId, { trashed: true }).then(response => {
				this.lawyersOffices = response.data.data;
				this.isLoading = false;
			});
		},
		disableRow(row) {
			const repairshopId = this.$store.getters.getUser.person.company.companyable.id;
			const lawyerOffice = this.lawyersOffices.find(lawyerOffice => lawyerOffice.id === row.id);

			this.$swal({
				title: this.$t('sure').toString(),
				text: lawyerOffice.isDisabled ? this.$t('activate_lawyers_office').toString() : this.$t('deactivate_lawyers_office').toString(),
				icon: 'warning',
				cancelButtonText: this.$t('general.no').toString(),
				showCancelButton: true,
				confirmButtonText: this.$t('general.yes').toString(),
			}).then(result => {
				if (result.value) {
					RepairShopRepository.disableLawyerOffice(repairshopId, lawyerOffice.id, !lawyerOffice.isDisabled).then(() => {
						this.$set(lawyerOffice, 'isDisabled', !lawyerOffice.isDisabled);
					});
				}
			});
		},
	},
	mounted() {
		this.isLoading = true;
		this.getLawyers();
	},
};
</script>

<style scoped></style>
